import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retry, tap } from 'rxjs/operators';

import { environment } from './../environments/environment';
import { Logger } from './logger';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  private ErrorLogUrl = environment.apiUrl + 'api/v1/errorlog/';  // URL to web api

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * Log an error
   * @param rref - Roughcheck reference
   * @param aref - Roughcheck assessment reference
   * @param errorcode - Error Code
   * @param errormessage - Error message
   * @param result - Logger object
   */
  logError(
    rref: string,
    aref: string,
    error: HttpErrorResponse,
    errormessage?: any
  );
  logError(
    rref: string,
    aref: string,
    error: any,
    errormessage?: string
  ): Observable<Logger> {
    // responseType: 'json';
    // method: 'PUT';
    const data = {
      rref: '',
      aref: '',
      errorcode: '',
      errormessage: '',
    };
    data.rref = rref;
    data.aref = aref;
    if (error instanceof HttpErrorResponse) {
      // Server Error
      data.errorcode = error.error.code;
      data.errormessage = error.error.message;
    } else {
      // Client Error
      if (error) {
        data.errorcode = error;
      }
      if (errormessage) {
        data.errormessage = errormessage;
      }
    }
    return this.http.put<Logger>(this.ErrorLogUrl, data, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }
}
